const videoLibrary = {
  CockBallsTie: "lnX-zRnqA94",
  BallSeperation: "-ZYUVJwSBio",
  CockBallWrapping: "YcnhFFapoH4",
  BallWrapping: "2XAEket8d8w"
};

export default videoLibrary;



// WEBPACK FOOTER //
// ./src/video/index.js